module.exports = __webpack_public_path__ + "media/video.11a56f4a.mp4";